import React from "react";
import {List} from "../modules/ActiveHarvests";

export function ActiveHarvestsListPage() {
  return (
    <List />
  );
}
